import { useState } from 'react'
// @mui
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Stack,
  Typography,
} from '@mui/material'
// constants
import { TERMS_CONDITION_URL } from '~/config'
import { PATH_DASHBOARD } from 'routes/paths'
// components
import Image from 'components/Image'
import Page from 'components/Page'
import Layout from '~/layouts'
import HeaderBreadcrumbs from 'components/HeaderBreadcrumbs'
import { PhoneVerificationModal } from 'domains/Users/Verification/containers/PhoneVerificationModal'
// hooks
import useSettings from 'hooks/useSettings'
import { useBoundVerificationUserStore } from 'domains/Users/Verification/stores'
import useAuth from 'hooks/useAuth'
import useSession from 'hooks/commons/useSession'
// styles
import { StyledBaseContainer } from '~/commons/styled'
import config from 'configs/app'

import useLocales from 'hooks/useLocales'

export default function RejectedPage({ setEditingMode }) {
  const [
    isPhoneVerificationDialogVisible,
    setIsPhoneVerificationDialogVisible,
  ] = useState(false)

  const { personalData, setActiveStep } =
    useBoundVerificationUserStore((state) => ({
      setActiveStep: state.setActiveStep,
      personalData: state.personalData,
    }))
  const { themeStretch } = useSettings()
  const { user } = useAuth()
  const { canPerform } = useSession()
  const { t } = useLocales()

  return (
    <Layout>
      <Page title={t('key_data_verification_input')}>
        <Container maxWidth={themeStretch ? false : 'xl'}>
          <HeaderBreadcrumbs
            heading={t('key_data_verification_input')}
            links={[
              { name: 'Dashboard', href: PATH_DASHBOARD.root },
              {
                name: t('key_data_verification'),
                href: PATH_DASHBOARD.general.verification.root,
              },

              {
                name: t('key_data_verification_input'),
              },
            ]}
          />
          <Box
            sx={(theme) => ({
              [theme.breakpoints.up('md')]: {
                maxWidth: '720px',
              },
              margin: '0px auto',
            })}
          >
            <StyledBaseContainer>
              <Grid container spacing={2.5}>
                <Grid container item xs={12} justifyContent="center">
                  <Image
                    alt="rejected-kyc-illustartion"
                    src={`${config.assetBaseUrl}/webp/illustrations/illustration_components.webp`}
                    sx={{ width: '176px' }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Stack gap={1.5}>
                    <Typography variant="h4" textAlign="center">
                      {t('key_verification_data_rejected')}
                    </Typography>
                    <Typography textAlign="center" variant="body2">
                      {t('key_your_data_was_rejected_due_to', {
                        reason: personalData?.reject_reason,
                      })}
                    </Typography>
                  </Stack>
                </Grid>

                <Grid item xs={12}>
                  <Stack direction="row" gap={1}>
                    <Button
                      id="b-users-rejectedpage-contact-cs"
                      variant="outlined"
                      sx={{ flex: 1 }}
                      onClick={() => {
                        window.open(
                          config.supportCenterUrl + 'home',
                          '_blank',
                        )
                      }}
                    >
                      {t('key_contact_cs')}
                    </Button>
                    {/* kyc:edit, not kyc:create: the record already exists and
                        is being corrected. Same button, same rule, as the
                        re-verify CTA on the voucher page. Contact CS stays
                        available either way. */}
                    {canPerform('kyc:edit') && (
                      <Button
                        id="b-users-rejectedpage-re-verification"
                        variant="contained"
                        sx={{ flex: 1 }}
                        onClick={() => {
                          if (!user?.phone) {
                            setIsPhoneVerificationDialogVisible(true)
                          } else {
                            setActiveStep(0)
                            setEditingMode(true)
                          }
                        }}
                      >
                        {t('key_re_verification')}
                      </Button>
                    )}
                  </Stack>
                </Grid>

                <Grid item xs={12}>
                  <Divider />
                </Grid>

                <Grid item xs={12} justifyContent="center">
                  <Typography variant="body2" textAlign="center">
                    {t('key_read')}{' '}
                    <Typography
                      id="l-users-rejectedpage-terms"
                      role="link"
                      variant="body2"
                      onClick={() => {
                        window.open(
                          `${TERMS_CONDITION_URL}#Aplikasi,-Akun-dan-Keamanan`,
                          '_blank',
                        )
                      }}
                      sx={(theme) => ({
                        color: theme.palette.info.main,
                        display: 'inline',
                        cursor: 'pointer',
                      })}
                    >
                      {t('key_terms_and_conditions')}
                    </Typography>{' '}
                    TipTip
                  </Typography>
                </Grid>
              </Grid>
            </StyledBaseContainer>
          </Box>
        </Container>
        <PhoneVerificationModal
          openDialog={setIsPhoneVerificationDialogVisible}
          open={isPhoneVerificationDialogVisible}
        />
      </Page>
    </Layout>
  )
}
